import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link } from '@tanstack/react-router';

interface BreadcrumbItem {
  href?: string;
  label: string;
}

interface BreadcrumbProps {
  path: BreadcrumbItem[];
}

export function Breadcrumb({ path }: BreadcrumbProps) {
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{ mb: 1, '& .MuiBreadcrumbs-ol': { color: 'text.secondary' } }}
      separator={<Typography variant="caption" sx={{ mx: 0.5, color: 'text.disabled' }}>/</Typography>}
    >
      {path.map((item, index) => {
        const isLast = index === path.length - 1;

        // Last item or item without href - render as plain text
        if (isLast || !item.href) {
          return (
            <Typography
              key={index}
              color="text.primary"
              sx={{ fontSize: '0.75rem', fontWeight: 500 }}
            >
              {item.label}
            </Typography>
          );
        }

        // Item with href - render as clickable link
        return (
          <MuiLink
            key={index}
            component={Link}
            to={item.href}
            color="inherit"
            underline="hover"
            sx={{ fontSize: '0.75rem', fontWeight: 500 }}
          >
            {item.label}
          </MuiLink>
        );
      })}
    </Breadcrumbs>
  );
}
